export default "__VITE_ASSET__vQGq04nE__"